module.exports = __webpack_public_path__ + "static/IMG_1535-385667e870519e2fa6c3fa0808726a21.jpg";